import { FunctionComponent, memo } from 'react';
import { StoryCardEditorialContent } from '../../../services';
import { FeedCardContentCommon, FeedCardProps } from '../../../shared';

export const FeedCardAdminEditorial: FunctionComponent<FeedCardProps> = memo(({ card }) => {
  const {
    storyId,
    id,
    type,
    content,
    isPinnedToTopOfNewsFeed,
    isPinnedToTopOfStory,
    mentionedUsers,
  } = card;

  const { sourceName, headline, subHeadline, text, textHTML } =
    content as StoryCardEditorialContent;

  return (
    <FeedCardContentCommon
      type={type}
      isPinnedToTopOfNewsFeed={isPinnedToTopOfNewsFeed}
      isPinnedToTopOfStory={isPinnedToTopOfStory}
      storyId={storyId}
      cardId={id}
      source={sourceName}
      title={headline}
      subTitle={subHeadline}
      text={text}
      htmlText={textHTML}
      mentionedUsers={mentionedUsers}
    />
  );
});
